"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9093],{

/***/ 68840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ FiCalendar; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FiCalendar(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "18",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "2",
        "x2": "16",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "2",
        "x2": "8",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "10",
        "x2": "21",
        "y2": "10"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 28613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ FiFilter; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FiFilter(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 38626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98989);
/* harmony import */ var components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68840);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);





/** ========== */





var PostItem = function PostItem(_ref) {
  var _post$categories;

  var post = _ref.post,
      layout = _ref.layout;
  var category = post === null || post === void 0 ? void 0 : (_post$categories = post.categories) === null || _post$categories === void 0 ? void 0 : _post$categories.nodes.filter(function (item) {
    return item.parent === null;
  });

  if (layout === "vertical") {
    var _post$featuredImage;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: "flex h-full flex-1 flex-col rounded-3xl bg-white transition-shadow duration-150 hover:shadow-[0px_0px_20px_#7c787833] xl:max-w-sm",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        image: post === null || post === void 0 ? void 0 : (_post$featuredImage = post.featuredImage) === null || _post$featuredImage === void 0 ? void 0 : _post$featuredImage.node,
        wrapper: {
          className: "w-full relative"
        },
        className: "aspect-[16/9] h-full w-full rounded-t-3xl object-cover"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "flex flex-1 flex-col justify-between p-6",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            as: "h3",
            className: "text-lg font-semibold text-bbc-brand-800 line-clamp-2",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              href: post === null || post === void 0 ? void 0 : post.uri,
              children: post === null || post === void 0 ? void 0 : post.title
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: "mt-4 line-clamp-3",
            dangerouslySetInnerHTML: {
              __html: post === null || post === void 0 ? void 0 : post.excerpt
            }
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "flex flex-wrap justify-between",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "mt-6 inline-flex items-center rounded-md bg-bbc-brand-800 px-2 py-0.5",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              src: "/assets/icons/".concat(category[0].name.toLowerCase(), ".svg"),
              alt: "icon",
              width: 16,
              height: 16
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              className: "inline-block pl-[5px] text-sm font-medium text-white",
              children: category.length > 0 && category[0].name
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: "mt-6 inline-flex items-center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_0__/* .FiCalendar */ .v, {
              size: 18
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
              className: "inline-block pl-2 text-sm",
              children: (0,common_functions__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p)(post === null || post === void 0 ? void 0 : post.date)
            })]
          })]
        })]
      })]
    });
  }

  if (layout === "horizontal") {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: "text-bbc-brand-700",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          as: "h3",
          className: "text-lg font-medium line-clamp-2",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            href: post === null || post === void 0 ? void 0 : post.uri,
            children: post === null || post === void 0 ? void 0 : post.title
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: "mt-6 inline-flex items-center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_0__/* .FiCalendar */ .v, {
            size: 18
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
            className: "inline-block pl-2 text-sm",
            children: (0,common_functions__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p)(post === null || post === void 0 ? void 0 : post.date)
          })]
        })]
      })
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {});
};

/* harmony default export */ __webpack_exports__["Z"] = (PostItem);
PostItem.defaultProps = {
  post: {},
  layout: "vertical"
};
/** ========== */

/***/ }),

/***/ 85244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src433047331_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56727);
/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(98989);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Icon_fa_FaSearch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53253);
/* harmony import */ var components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68840);
/* harmony import */ var components_atoms_Icon_fi_FiChevronDown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49604);
/* harmony import */ var components_atoms_Icon_fi_FiFilter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28613);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_FormNewsletter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(32314);
/* harmony import */ var components_molecules_PostItem__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(38626);
/* harmony import */ var components_organisms_Banner__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47447);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src433047331_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















var Articles = function Articles(_ref) {
  var _data$dropdownData, _firstPost$categories, _data$banner, _data$banner2, _data$banner3, _data$banner4, _data$dropdownData3, _firstPost$featuredIm;

  var data = _ref.data,
      posts = _ref.posts;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(data !== null && data !== void 0 && data.dropdownData ? data === null || data === void 0 ? void 0 : (_data$dropdownData = data.dropdownData) === null || _data$dropdownData === void 0 ? void 0 : _data$dropdownData.data[0] : {
    value: "all"
  }),
      country = _useState[0],
      setCountry = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(),
      keyWord = _useState2[0],
      setkeyWord = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      filter = _useState3[0],
      setFilter = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]),
      results = _useState4[0],
      setResults = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(9),
      perPage = _useState5[0],
      setPerPage = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var firstPost = posts[0] || null;
  var category = firstPost === null || firstPost === void 0 ? void 0 : (_firstPost$categories = firstPost.categories) === null || _firstPost$categories === void 0 ? void 0 : _firstPost$categories.nodes.filter(function (item) {
    return item.parent === null;
  });
  var listPost = posts.length > 1 ? posts.filter(function (item, index) {
    return index > 0;
  }) : [];
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var result = posts;

    if (keyWord) {
      var keyWordLowerCase = keyWord.toLowerCase().trim();
      result = result.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.title.toLowerCase().trim().includes(keyWordLowerCase)) || (item === null || item === void 0 ? void 0 : item.excerpt.replace(/<[^>]+>/g, "").toLowerCase().trim().includes(keyWordLowerCase));
      });
    }

    if (country.value !== "all") {
      var _data$dropdownData2;

      setFilter(true);

      if ((data === null || data === void 0 ? void 0 : (_data$dropdownData2 = data.dropdownData) === null || _data$dropdownData2 === void 0 ? void 0 : _data$dropdownData2.type) === "categories") {
        result = result.filter(function (item) {
          return item.categories.nodes.find(function (node) {
            return node.name === country.value;
          });
        });
      } else {
        result = result.filter(function (item) {
          return item.tags.nodes.find(function (node) {
            return node.name === country.value;
          });
        });
      }
    }

    if (!keyWord && country.value === "all") {
      setFilter(false);
      result = [];
    }

    setResults(result); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyWord, country]);

  var handleSearch = function handleSearch(keyWord) {
    var keyWordLowerCase = keyWord.toLowerCase().trim();
    setkeyWord(keyWordLowerCase);
  };

  var handleLoadMore = function handleLoadMore() {
    setIsLoading(!isLoading);
    setTimeout(function () {
      var currentPerPage = perPage + 6;
      setPerPage(currentPerPage);
      setIsLoading(false);
    }, 500);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("section", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_organisms_Banner__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        minHeightBanner: "banner-min-h-569",
        title: data === null || data === void 0 ? void 0 : (_data$banner = data.banner) === null || _data$banner === void 0 ? void 0 : _data$banner.title // Author="Content team"
        ,
        breadcrumbs: data === null || data === void 0 ? void 0 : (_data$banner2 = data.banner) === null || _data$banner2 === void 0 ? void 0 : _data$banner2.breadcrumbs,
        description: data === null || data === void 0 ? void 0 : (_data$banner3 = data.banner) === null || _data$banner3 === void 0 ? void 0 : _data$banner3.description,
        bgColor: "bg-bbc-gradient-8",
        leftClassName: "lg:col-6",
        rightClassName: "lg:col-5",
        rightContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, _objectSpread({
          wrapper: {
            className: "bbc-banner-image-country xl:top-24"
          },
          alt: "banner",
          priority: true
        }, data === null || data === void 0 ? void 0 : (_data$banner4 = data.banner) === null || _data$banner4 === void 0 ? void 0 : _data$banner4.image))
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("section", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
          className: "row",
          children: [(data === null || data === void 0 ? void 0 : data.searchBar) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
            className: "col-12 lg:col-8",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
              className: "overflow-hidden rounded-[49px] border border-bbc-neutral-600",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
                className: "row",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
                  className: "col",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("input", {
                    type: "text",
                    placeholder: "Enter your keyword",
                    onChange: function onChange(e) {
                      return handleSearch(e.target.value);
                    },
                    className: "form-input h-10 w-full border-0 bg-transparent px-4 tracking-[0.25px] text-[rgba(51,51,51,0.5)] focus:ring-0"
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
                  className: "col-auto flex items-center justify-center",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
                    className: "px-4",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_atoms_Icon_fa_FaSearch__WEBPACK_IMPORTED_MODULE_3__/* .FaSearch */ .U, {
                      className: "text-bbc-neutral-600",
                      size: 18
                    })
                  })
                })]
              })
            })
          }), (data === null || data === void 0 ? void 0 : (_data$dropdownData3 = data.dropdownData) === null || _data$dropdownData3 === void 0 ? void 0 : _data$dropdownData3.data) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
            className: "col-12 mt-6 lg:col-4 lg:mt-0",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_14__/* .Listbox */ .Ri, {
              as: "div",
              value: country,
              onChange: function onChange(value) {
                setCountry(value);
              },
              className: "relative w-full rounded-full border border-bbc-neutral-600",
              style: {
                height: "42px"
              },
              children: function children(_ref2) {
                var _data$dropdownData4;

                var open = _ref2.open;
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_14__/* .Listbox.Button */ .Ri.Button, {
                    as: "div",
                    role: "button",
                    className: "relative h-full w-full  select-none pl-4 pr-9 text-left focus:outline-0",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
                      className: "flex h-full items-center gap-x-2",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_atoms_Icon_fi_FiFilter__WEBPACK_IMPORTED_MODULE_6__/* .FiFilter */ .I, {
                        className: "text-bbc-neutral-600",
                        size: 20
                      }), (country === null || country === void 0 ? void 0 : country.icon) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        src: "/assets/flags/1x1/".concat(country.icon, ".svg"),
                        width: 24,
                        height: 24,
                        className: "rounded-full",
                        style: {
                          minHeight: "24px",
                          minWidth: "24px"
                        },
                        alt: country.icon
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("span", {
                        className: "tracking-[0.25px truncate",
                        style: {
                          color: "#33333380"
                        },
                        children: country.label
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_atoms_Icon_fi_FiChevronDown__WEBPACK_IMPORTED_MODULE_5__/* .FiChevronDown */ .b, {
                        className: "absolute right-4 top-1/2 float-right -translate-y-1/2 transform align-middle text-bbc-neutral-600  ".concat(open ? "rotate-180" : "rotate-0", " transition-all duration-200"),
                        size: 24
                      })]
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_14__/* .Transition */ .uT, {
                    show: open,
                    leave: "transition-all duration-200 ease-out",
                    leaveFrom: "opacity-50",
                    leaveTo: "opacity-0",
                    className: "absolute z-10 mt-2 w-full",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
                      className: "overflow-hidden rounded-xl shadow-md",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_14__/* .Listbox.Options */ .Ri.Options, {
                        className: "max-h-60 overflow-auto bg-white focus:outline-none",
                        children: data === null || data === void 0 ? void 0 : (_data$dropdownData4 = data.dropdownData) === null || _data$dropdownData4 === void 0 ? void 0 : _data$dropdownData4.data.map(function (item, itemIdx) {
                          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_14__/* .Listbox.Option */ .Ri.Option, {
                            className: "list-none",
                            value: item,
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
                              className: "flex cursor-pointer items-center gap-x-3 px-4 py-3 font-medium ".concat(country.label === item.label ? "bg-bbc-primary text-white" : "hover:bg-bbc-primary hover:bg-opacity-40") // OnClick={() => setCountry(item)}
                              ,
                              children: [(item === null || item === void 0 ? void 0 : item.icon) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                src: "/assets/flags/1x1/".concat(item.icon, ".svg"),
                                width: 24,
                                height: 24,
                                style: {
                                  minHeight: "24px",
                                  minWidth: "24px"
                                },
                                className: "rounded-full",
                                alt: item.icon
                              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("span", {
                                className: "truncate",
                                children: item.label
                              })]
                            })
                          }, itemIdx);
                        })
                      })
                    })
                  })]
                });
              }
            })
          })]
        }), !keyWord && !filter ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
          className: "mt-10",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
            children: !keyWord && firstPost ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
              className: "overflow-hidden rounded-3xl bg-white transition-shadow duration-150 hover:shadow-[0px_0px_20px_rgba(124,120,120,0.2)]",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
                className: "flex flex-col lg:flex-row",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
                  className: "pr-0 lg:col-8 lg:pr-[15px]",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    alt: "",
                    image: firstPost === null || firstPost === void 0 ? void 0 : (_firstPost$featuredIm = firstPost.featuredImage) === null || _firstPost$featuredIm === void 0 ? void 0 : _firstPost$featuredIm.node,
                    wrapper: {
                      className: "w-full relative"
                    },
                    className: "aspect-[16/9] h-full w-full object-cover"
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
                  className: "col-12 flex flex-col justify-center px-[15px] py-4 lg:col-4",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    as: "h3",
                    className: "text-lg  font-semibold text-bbc-brand-800 line-clamp-2 lg:text-2xl lg:leading-9 lg:line-clamp-3",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                      href: firstPost === null || firstPost === void 0 ? void 0 : firstPost.uri,
                      children: firstPost === null || firstPost === void 0 ? void 0 : firstPost.title
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
                    className: "mt-4 line-clamp-3 lg:mt-6",
                    dangerouslySetInnerHTML: {
                      __html: firstPost.excerpt
                    }
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
                    className: "flex flex-wrap justify-between",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
                      className: "mt-6 inline-flex items-center rounded-md bg-bbc-brand-800 px-2 py-0.5",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        src: "/assets/icons/".concat(category[0].name.toLowerCase(), ".svg"),
                        alt: "icon",
                        width: 16,
                        height: 16
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("span", {
                        className: "inline-block pl-[5px] text-sm font-medium text-white",
                        children: category.length > 0 && category[0].name
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
                      className: "mt-6 inline-flex items-center",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_atoms_Icon_fi_FiCalendar__WEBPACK_IMPORTED_MODULE_4__/* .FiCalendar */ .v, {
                        size: 18
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("span", {
                        className: "inline-block pl-2 text-sm",
                        children: (0,common_functions__WEBPACK_IMPORTED_MODULE_15__/* .formatDate */ .p)(firstPost === null || firstPost === void 0 ? void 0 : firstPost.date)
                      })]
                    })]
                  })]
                })]
              })
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {})
          })
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {}), !keyWord && !filter && listPost.length > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
            className: "row mt-10 gap-y-10 lg:mt-20 lg:gap-y-20",
            children: listPost.map(function (item, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
                className: "col-12 lg:col-4 ".concat(index < perPage ? "" : "hidden"),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_molecules_PostItem__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                  post: item
                })
              }, index);
            })
          }), perPage < listPost.length ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
            className: "mt-10 text-center",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              othersClass: "".concat(isLoading ? "cursor-not-allowed" : ""),
              onClick: handleLoadMore,
              disabled: isLoading,
              children: isLoading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
                className: "flex items-center",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("svg", {
                  className: "text-primary mr-2 h-5 w-5 animate-spin group-hover:text-white",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("circle", {
                    className: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    strokeWidth: 4
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("path", {
                    className: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  })]
                }), "Loading..."]
              }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {
                children: "Load more"
              })
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {})]
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {}), results.length > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
          className: "row -mx-4 mt-8 gap-y-8",
          children: results.map(function (item, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
              className: "col-12 px-4 lg:col-4",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_molecules_PostItem__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                post: item
              })
            }, index);
          })
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {}), (keyWord || filter) && !(results.length > 0) || !posts || !(posts.length > 0) ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
          className: "border-primary text-primary mt-8 border-l-4 bg-[#fff5e3] py-4 px-6 text-center",
          children: "No results"
        }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {})]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(components_molecules_FormNewsletter__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Articles);
Articles.defaultProps = {
  data: {},
  posts: []
};

/***/ }),

/***/ 34853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm; }
});

// UNUSED EXPORTS: ReCAPTCHA

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);


/***/ })

}]);